import ItemModel from './item-model'
import Collection from "../../data-structures/collection"
import Resources from "../../resources/resources"
import Task from '../task/task'
import Project from "../project/project"
import {EntityType} from "../../gd/const/item"
import itemsCollection_initTree from "./helpers/init-tree"
import initExpensesFromResources from "./init/init-expenses-from-resources"
import listItem_UpdateDisplayNumberRecursively from "./helpers/update-display-numbers"
import ProjectSession from "../project/project-session"
import SessionCustomField from "../custom-field/session-custom-field"
import User from "../user/user"
import {SortDirection} from "../../data-structures/sort"
import {ProjectItem} from "../project-item/project-item"
import {InitItemsCollectionOptions} from "./@type"
import {ProjectItemOrigin} from "../project-item/@type"
import ItemModelV2 from "../item2/item-model"

// const debug = "ItemsCollection"
const debug = false

export default class ItemsCollection extends Collection<ItemModel> {

    public rootProjectIds           : ID[] = []
    public treeRoots                : ItemModel[] = []

    public includeMultiProjectTasks : boolean = false

    protected byTaskId              : {[key:ID]:ItemModel[]}  = {}

    constructor(models: ItemModel[] = []) {
        super(models)
    }

    static initFormResources(resources: Resources, options?: InitItemsCollectionOptions):ItemsCollection {

        const includeMultiProjectTasks = gd.company.settings.labs.multipleTaskProjectsSupport && !!options?.includeMultiProjectTasks

        const itemsCollection = new ItemsCollection()
        itemsCollection.includeMultiProjectTasks = includeMultiProjectTasks

        _.map(resources.tasks?.models, (task: Task) => {
            // Each task may be linked to multiple projectItems
            _.map(task.projects, (projectItem: ProjectItem) => {
                // Add if including multi-project tasks, or only add main project association
                if (includeMultiProjectTasks || projectItem.origin === ProjectItemOrigin.MAIN) {
                    itemsCollection.add(
                        ItemModel.initForTask(task, itemsCollection, projectItem)
                    )
                }
            })

            // itemsCollection.add(
                // ItemModel.initForTask(task, itemsCollection,...)
            // )

        })
        // resources.tasks!.models.map()

        _.map(resources.projects?.models, (project:Project)=>{
            // model.item.initCrmAccountInheritance()
            itemsCollection.add(new ItemModel(project, itemsCollection) )
        })

        return itemsCollection
    }

    reset(models?: ItemModel[]) {
        this.byTaskId = {}

        super.reset(models)
    }

    // redefined becuase id is RID
    get(id: RID):ItemModel | null {
        return this.byId[id]
    }

    addTask(task: Task, projectItem: ProjectItem) {
        this.add(ItemModel.initForTask(task, this, projectItem))
    }

    addProject(project:ProjectSession) {
        const modelData = { type: EntityType.PROJECT, item: project }
        this.add(new ItemModel(modelData, this))
    }

    // remove project and all of it's children
    removeProject(rid: RID) {
        this.recursiveRemoveWithChildren(this.get(rid))
    }

    recursiveRemoveWithChildren(model: ItemModel | null) {
        if (!model) return

        this.remove(model.id)

        _.map(model.treeChildren, (child: ItemModel) => {
            this.recursiveRemoveWithChildren(child)
        })
    }

    initExpensesFromResources(resources:Resources) {
        return initExpensesFromResources(this, resources)
    }


    // find all tasks items which are visible && Selected
    get tasksVisibleSelected():ItemModel[] {
        return _.filter(this.models, (item:ItemModel)=>{
            return item.isVisible && item.isTask && item.isSelected
        }) as ItemModel[]
    }

    add(model:ItemModel) {

        const existingModel = this.get(model.id)
        if (existingModel) {
            console.log("#842274uu ItemsCollection Model", model.id, "already existis -> Skip")
            return
        }

        if (model.isTask) {
            if (!this.byTaskId[model.task.id]) {
                this.byTaskId[model.task.id] = []
            }

            this.byTaskId[model.task.id].push(model)
        }

        super.add(model)
    }

    remove(id: ID): ItemModel[] {
        const removed = super.remove(id)

        if (removed[0]?.isTask) {
            _.remove(this.byTaskId[removed[0].task.id], (taskItem: ItemModel) => {
                return taskItem.id === id
            })
        }

        return removed
    }

    initTree() {
        itemsCollection_initTree(this)
    }

    public clearTree() {
        this.treeRoots = []

        _.map(this.models, (listItem)=> {
            listItem.treeChildren   = [];
            listItem.treeParent     = undefined
        })
    }

    /*// deprecated - used when it was ameprasnd collection
    map(callback:any) {
        return _.map(this.models, (item, key)=>callback(item, key));
    }

    // deprecated - used when it was ameprasnd collection
    filter(callback:any):ItemModel[] {
        return _.filter(this.models, (item, key)=>callback(item, key)) as ItemModel[];
    }*/

    addTasksAndProjects(tasks?: any[], projects?: any[]) {
        debug && console.log(debug, "addTasksAndProjects", tasks, projects)

        _.map(tasks, (task: any)=> {
            _.map(task.projects, (projectItem: ProjectItem) => {
                this.add(
                    ItemModel.initForTask({
                        type: EntityType.TASK,
                        item: task
                    }, this, projectItem)
                )
            })
        })

        _.map(projects, (project: any)=>{
            this.add(new ItemModel({
                type: EntityType.PROJECT,
                item: project
            }, this))
        })
    }

    updateChildrenItems(skipId?:RID) {
        debug && console.log(debug, "Update children items")
        _.map(this.models, (listItem)=>{
            listItem.childrenItems = [];
        })

        _.map(this.models, (listItem)=>{
            if (listItem.parentId && listItem.id !== skipId) {
                const parent = this.get(listItem.parentId);
                if (parent) {
                    parent.childrenItems.push(listItem.id);
                    parent.updateLastUpdateTime()
                }
                // else console.warn("ItemsCollection updateChildrenItems: no parent item found for parentId", listItem.parentId);
            }
        })

        this.initTree();

        this.updateCalculatedValues()
        this.updateDisplayNumbers()
    }

    updateCalculatedValues() {

        debug && console.log(debug,"updateCalculatedValues() this.treeRoots=",this.treeRoots )

        _.map(this.treeRoots, (item:ItemModel)=>{
            item.updateCalculatedValuesNew()
        })

    }

    updateDisplayNumbers() {
        debug && console.log(debug,"updateDisplayNumbers", this.treeRoots)

        let counter = 0
        _.map(this.treeRoots, (item:ItemModel)=>{
            counter = listItem_UpdateDisplayNumberRecursively(undefined, item, counter)
        })
    }

    markEmptyProjects() {
        debug && console.log(debug, "markEmptyProjects()")
        _.map(this.models, listItem => {
            if (listItem.isProject) {
                if(!listItem.numChildren ||
                    (listItem.numChildren.tasks === 0 &&
                        listItem.numChildren.projectTasksTotal === 0)) {
                    listItem.isEmptyProject = true
                }
            }
        })
    }

    applyTaskDelta(taskId: ID, data: any) {
        let isChanged = false
        const models: ItemModel[] = this.getTaskItems(taskId)

        if (data.projects) {
            // if projects are changed then some task items are removed and/or added
            // we need to remove all previous task items and create new one with correct ids
            const task = models[0]?.task || new Task(data)

            const prevViewSortPositions: Record<ID, number> = {}
            _.map(models?.slice(), (itemModel: ItemModelV2) => {
                this.remove(itemModel.id)
                prevViewSortPositions[itemModel.id] = itemModel.view.sortPosition
            })

            let projects: ProjectItem[] = _.map(data.projects, (data: any) => {
                return new ProjectItem(data, task)
            })

            _.map(projects, (projectItem: ProjectItem) => {
                if (this.includeMultiProjectTasks || projectItem.origin === ProjectItemOrigin.MAIN) {
                    const itemModel = ItemModel.initForTask(task, this, projectItem)
                    this.add(itemModel)

                    if (prevViewSortPositions[itemModel.id]) {
                        itemModel.viewSortPosition = prevViewSortPositions[itemModel.id]
                    }

                    const parent = this.getProject(projectItem.projectId)
                    if (parent) {
                        itemModel.treeParent = parent
                    }

                    itemModel.applyDelta(data)
                }
            })

            // since new items are instantiated for each project, changes are guaranteed
            isChanged = true
        } else {
            _.map(models, (model) => {
                const applyResult = model.applyDelta(data)
                if (!isChanged && applyResult) {
                    isChanged = true
                }
            })
        }

        if (!!data.projectId || data.hasOwnProperty('parentTaskId')) {
            this.updateChildrenItems()
        }

        return isChanged
    }

    applyProjectDelta(projectId:ID, data:any) {
        let isChanged = false
        const model = this.getProject(projectId)
        if (model) isChanged = model.applyDelta(data)

        if (!!data.parentId) this.updateChildrenItems()

        return isChanged
    }

    getTaskItems(taskId: ID) {
        /*const rid = `t-${taskId}`
        const prefix = rid + '-'
        return _.filter(this.models, (item: ItemModel) => {
            return item.id.startsWith(prefix)
        })*/

        return this.byTaskId[taskId]
    }

    getTask(id: ID, projectId: ID)     {
        return this.get("t-{0}-{1}".f(id, projectId))
    }

    // maybe not deprecated ... it's get projectById ... but I think deprecated... dont like it... deprecated use getProject2
    getProject(id:ID)  {
        return this.get("p-{0}".f(id))
    }

    findMarkerByEntityId(entityId: ID, defaultAddressFieldId: ID) {
        return this.models.find((item: ItemModel)=> {
            return item.id === entityId
        })?.marker(defaultAddressFieldId)
    }

    /*getProjectChildren(id:ID):ItemsCollection {

        const res:ItemModel[]   = [];
        const projectItem       = this.getProject(id);

        const recursiveCollectChildren = (childrenItems:any) => {
            childrenItems.map((cI:RID) => {
                const cItem = this.get(cI);
                if (cItem) {
                    // console.log("### zachem ???? ")
                    res.push(cItem.clone());  // uuuu.... uuuu.... a zachem mi voobche new list item delaem
                    recursiveCollectChildren(cItem.childrenItems);
                }
            })
        };

        if (projectItem) recursiveCollectChildren(projectItem.childrenItems);

        res.map((item) => {
            // hm...
            if (projectItem && item.parentId === projectItem.id) item.parentId = null
        });

        return new ItemsCollection(res);
    }

    getProjectParents(id:ID) {
        const res = new ItemsCollection();
        const projectItem = this.getProject(id);

        const recursiveCollectParent = (parentId:RID) => {
            const pItem = this.get(parentId);
            if(pItem){
                res.add(pItem);

                if (pItem.parentId) {
                    recursiveCollectParent(pItem.parentId);
                }

            }
        };

        if (projectItem && projectItem.parentId) recursiveCollectParent(projectItem.parentId);

        return res;
    }

    findRootProjects():ID[] {
        // used in custom table view when we show all projects and need root ones
        // I think this is BAD but again... it's for ALL project only i.e. no projects specified
        const rootProjects : ItemModel[] = _.filter(this.models, (item)=>{
            return item.isProject && !item.project.parentId
        })

        return _.map(rootProjects, (item)=>{return item.project.id})

    }*/

    findRootProjectsV2():ID[] {

        let rootProjectIds : ID[] = []

        // used in custom table view when we show all projects and need root ones
        // also my tasks
        _.map(this.models, (item)=>{
            if (item.isProject && !item.treeParent) {
                rootProjectIds.push(item.project.id)
            }
        })

        return rootProjectIds

    }


    getProjects(openOnly:boolean=false) {


        const models : ItemModel[] = _.filter(this.models, (listItem)=>{
           return listItem.isProject && (!openOnly || gd.const.systemStatus.isOpen(listItem.item.systemStatus))
        }) as ItemModel[]

        const itemsCollection = new ItemsCollection()
        itemsCollection.reset(models)

        return itemsCollection
    }

    getTasks() {

        const models : ItemModel[] = _.filter(this.models, (listItem)=>{
            return listItem.isTask
        }) as ItemModel[]

        const itemsCollection = new ItemsCollection()
        itemsCollection.reset(models)

        return itemsCollection
    }

    get entitiesCustomFieldsMap(): {[key in EntityType]?: Set<SessionCustomField>} {
        let res: {[key in EntityType]?: Set<SessionCustomField>} = {}

        _.map(this.models, (itemModel: ItemModel) => {
            if (!res[itemModel.type]) {
                res[itemModel.type] = new Set()
            }

            _.map(itemModel.item.customFieldsData, (value: any, key: string) => {
                const customField = gd.session.customFields.get(key)
                if (customField) res[itemModel.type]?.add(customField)
            })
        })

        return res
    }

    debugTreeRoots() {
        console.blue("******** debug tree roots ***********")
        _.map(this.treeRoots, (item)=>{
            console.log(item.getName())
        })
        console.blue("---------------------------")
    }

    debugTree() {
        console.blue("******** debug tree ***********")
        const debugItem = (item:ItemModel, level=0) => {

            console.log('----'.repeat(level), item.getName(), "id=",  item.id, "display=", item.display, "parentId=", item.parentId, "calculatedExpenses", item.calculatedExpenses)
            _.map(item.treeChildren, (childrtenItem)=>{
                debugItem(childrtenItem, level+1)
            })
        }

        _.map(this.treeRoots, (item)=>{
            debugItem(item)
        })

    }

    debugTasks() {
        console.blue("******** debug tasks ***********")
        _.map(this.models, item=>{
            if (!item.isTask) return
            console.log(item.getName(), "id=",  item.id)
            console.log('    ', "treeParent=",  item.treeParent?.debugName)
            // console.log('    ', "numChildren=",  item.numChildren)
            console.log('    ', "expensesTotal=", item.task.expensesCollection?.total,"expensesCollection=",  item.task.expensesCollection)
        })
    }

    debugProjects() {
        console.blue("******** debug projects ***********")
        _.map(this.models, item=>{
            if (!item.isProject) return
            console.log(item.getName(), "id=",  item.id)
            console.log('    ', "parent=",  item.treeParent?.debugName)
        })
    }


    findAllTaskItemsInProject(projectId:ID):ItemModel[] {
        return _.filter(this.models, (itemModel: ItemModel)=>{
            // return i.isTask && i.task.projectId === projectId
            return itemModel.isTask && itemModel.projectItem?.projectId === projectId
        })
    }

    findAllProjectItemsInProject(projectId:ID):ItemModel[] {
        return _.filter(this.models, (i:ItemModel)=>{
            return i.isProject && i.project.parentId === projectId
        })
    }

    get selectedTasks():ItemModel[] {
        const tasks = _.filter(this.models,(i:ItemModel)=>{
            return i.isVisible && i.isTask && i.isSelected
        }) as ItemModel[]

        return tasks
    }

    get selectedOpenTasks(): ItemModel[] {
        return _.filter(this.models, (i:ItemModel)=>{
            // !gd.const.systemStatus.isClosed(i.item.systemStatus)
            return i.isVisible && i.isTask && i.isSelected && i.task.isOpen
        })
    }

    get users() {
        const res: Set<ID> = new Set()

        _.map(this.models, (itemModel:ItemModel)=>{
            if (itemModel.isTask) {
                if (itemModel.task.actionRequiredUserId) {
                    res.add(itemModel.task.actionRequiredUserId)
                }

                if (itemModel.task.assignedToUserId) {
                    res.add(itemModel.task.assignedToUserId)
                }
            }
        })


        return _([...res])
            .map((userId: ID) => {
                return gd.session.users.get(userId)
            })
            .compact()
            .orderBy((user: User) => {
                return user.name
            }, SortDirection.ASC)
            .value()
    }

    reorderByIds(orderedIds: ID[]) {
        super.reorderByIds(orderedIds)

        this.initTree()
    }
}



















